import { useRouter } from 'expo-router';
import { Image } from 'react-native';

import { LoyaltyPartnerTile } from '../loyalty-partner-tile';

const image = require('./mnt.png');

const MNT_URL = '/campaigns/mnt';

const MNT_IMAGE_WIDTH = 96;
const MNT_IMAGE_HEIGHT = 96;

export const MntCard = () => {
  const router = useRouter();

  const handlePress = () => {
    router.navigate(MNT_URL);
  };

  return (
    <LoyaltyPartnerTile
      onPress={handlePress}
      image={<Image style={{ width: MNT_IMAGE_WIDTH, height: MNT_IMAGE_HEIGHT }} source={image} />}
      title="BK & Mexican National Team"
      description={[
        'Proud Sponsor of El Tricolor!',
        'The Home of El Tricolor + BK is here! Visit for offers, chances to win and more!',
      ]}
      ctaLabel="Get Started"
      onCTAPress={handlePress}
    />
  );
};
